import { axiosAPIInstance as axios } from '../../axios-config';

const state = {
  editUpdateSubmitter: false,
};

const getters = {
  editUpdateSubmitter({ editUpdateSubmitter }) { return editUpdateSubmitter; },
};

const mutations = {
  submitEditUpdate(state) { state.editUpdateSubmitter = !(state.editUpdateSubmitter); },
};

const actions = {
  async createVoiceLine(_, voiceLine) {
    const response = await axios.post('/blade/voice-lines', voiceLine);
    return response.data.voiceLine;
  },

  async getVoiceLine(_, id) {
    const response = await axios.get(`/blade/voice-lines/${id}`);
    return response.data.voiceLine;
  },

  async updateVoiceLine(_, { id, voiceLine }) {
    const response = await axios.patch(`/blade/voice-lines/${id}`, voiceLine);
    return response.data.voiceLine;
  },

  async lockVoiceLine(_, { id, lock }) {
    const response = await axios.patch(`/blade/voice-lines/${id}/lock`, { lock });
    return response.data.voiceLine;
  },

  async lockVoiceLineVoiceSettings(_, { id, lock }) {
    const response = await axios.patch(`/blade/voice-lines/${id}/lockvoice`, { lock });
    return response.data.voiceLine;
  },

  async deleteVoiceLine(_, id) {
    const response = await axios.delete(`/blade/voice-lines/${id}`);
    return response.data.voiceLine;
  },

  async batchGenerateVoiceLines(_, { voiceLineIds }) {
    const response = await axios.patch('/blade/voice-lines/batch/generate', { voiceLineIds });
    return response.data;
  },

  /**
   * This can create VoiceLine objects with a yet-to-be-generated audioUrl; returns array of ids to send to batchGenerateVoiceLines.
   */
  async computeAllVoiceLineIdsToGenerateForGame(_, { gameId, fallbackVoice, fallbackGoogleTtsAudioConfig }) {
    const response = await axios.patch(`/blade/voice-lines/game/${gameId}`, { fallbackVoice, fallbackGoogleTtsAudioConfig });
    return response.data.voiceLineIds;
  },

  async getNumberOfPotentiallyGeneratedVoiceLinesInGame(_, { gameId, fallbackVoice, fallbackGoogleTtsAudioConfig }) {
    const response = await axios.patch(`/blade/voice-lines/game/${gameId}?dryRun=true`, { fallbackVoice, fallbackGoogleTtsAudioConfig });
    return response.data.count;
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/blade/voice-lines.js